import { Component, OnInit } from '@angular/core';
import { MatDrawerToggleResult, MatSidenav } from '@angular/material/sidenav';
import { NavigationEnd, Router } from '@angular/router';
import { GlobalVar } from '../../globals/global-var';
import { TokenService } from '../../services/token.service';
import { ClassService } from '../../services/class.service';
import { TeacherService } from '../../services/teacher.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit {

  navigationSubscription;
  sidenavMode = "side";

  constructor(private router: Router, private tokenService: TokenService, public globalVar: GlobalVar) {
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        if (window.innerHeight > window.innerWidth) {
          this.globalVar.menuShow = false;
          this.sidenavMode = "over";  //over,push,side
          this.globalVar.gridColsNum = 1;
        }
        else {
          this.globalVar.menuShow = true;
          this.sidenavMode = "side";
          this.globalVar.gridColsNum = 3;
        }
      }
    });

    
  }

  ngOnInit(): void {
    
  }

  ngOnDestroy(): void {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }


  logout() {
    this.tokenService.logout();
    this.router.navigate(['/login']);
    return false;
  }

  toggleSideNav(sideNav: MatSidenav) {
    sideNav.toggle().then((result: MatDrawerToggleResult) => {
      if (result == "close") {
        this.globalVar.menuShow = false;
      }
      else {
        this.globalVar.menuShow = true;
      }
    });
  }

}
